var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alert.length)?_c('div',{staticClass:"multisig_ban_container"},[_c('Alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.alert))+" ")]),_c('div',{staticClass:"is_multisig un_click radius"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }